import type { AxiosRequestConfig } from 'axios';
import type { ApiResponse, IProvinceListRequest, IWeekListRequest, IWeekListByMonthRequest } from './types';

import { v3Get, v3Post } from './axios.instance.V3';
import routes from '@/config/routes';
import { IClassRequest } from './types';

const prefixTime = '/time';
const prefixWeeklabel = '/weeklabel';
const prefixPub = '/pub';

const url = {
  getCurrentWeek: () => `${prefixWeeklabel}/get/current`,
  getCountriesList: () => `${prefixPub}/vocabcountry/g/list`,
  getProvincesList: (id: string) => `${prefixPub}/vocabprovince/g/list/vocabcountry/${id}`,
  getWeeksArray: ({ weekId, offsetMinus, offsetPlus }: IWeekListRequest) =>
    `${prefixWeeklabel}${prefixTime}/week/list/${weekId}/${offsetMinus}/${offsetPlus}`,
  getWeeksArrayByMonth: () => `${prefixWeeklabel}${prefixTime}/month`,
} as const;

const getCountriesList = (): ApiResponse => v3Get(url.getCountriesList());

const getProvincesList = (payload: IProvinceListRequest): ApiResponse =>
  v3Get(url.getProvincesList(payload.id.toString()));

const getCurrentWeek = (config?: AxiosRequestConfig): ApiResponse => v3Get(url.getCurrentWeek(), config);

const getWeeksArray = (payload: IWeekListRequest): ApiResponse => v3Get(url.getWeeksArray(payload));

const getWeeksArrayByMonth = (payload: IWeekListByMonthRequest): ApiResponse =>
  v3Post(url.getWeeksArrayByMonth(), payload);

const getMasUsers = (campaignId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.application.getMasUsers}${campaignId}`);

const getClasses = (payload: IClassRequest): ApiResponse =>
  v3Get(
    `${routes.backendUrl.application.getClasses}${payload.campaignId}/${payload.applicationStatusId}/${payload.selectedType}`,
  );

export const apiUtils = {
  getCountriesList,
  getProvincesList,
  getCurrentWeek,
  getWeeksArray,
  getWeeksArrayByMonth,
  getMasUsers,
  getClasses,
};
